import { render, staticRenderFns } from "./CreateExercises.vue?vue&type=template&id=ea52d6fc&scoped=true&"
import script from "./CreateExercises.vue?vue&type=script&lang=js&"
export * from "./CreateExercises.vue?vue&type=script&lang=js&"
import style0 from "./CreateExercises.vue?vue&type=style&index=0&id=ea52d6fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea52d6fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
